import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FrameDesktopComponent } from "../frame-desktop/frame-desktop.component";
import { FrameMobileComponent } from "../frame-mobile/frame-mobile.component";
import { FrameTabletComponent } from "../frame-tablet/frame-tablet.component";
import { MainScreenComponent } from "./main-screen.component";
import { RouterModule } from "@angular/router";
import { LoginModule } from "../../shared/login.module";

@NgModule({
  declarations: [
    FrameDesktopComponent,
    FrameMobileComponent,
    FrameTabletComponent,
    MainScreenComponent,
  ],
  imports: [CommonModule, RouterModule.forRoot([]), LoginModule],
  exports: [
    FrameDesktopComponent,
    FrameMobileComponent,
    FrameTabletComponent,
    MainScreenComponent,
  ],
})
export class MainScreenModule {}
